import { AxiosPromise } from 'axios';
import apiClient from 'configs/axios';

export interface WorkspaceType {
  id: number;
  feedbackId: number;
  name: string;
  organizationId: number;
  lastSyncedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export const fetchWorkspaces = (): AxiosPromise<WorkspaceType[]> =>
  apiClient.get('/workspaces');

export const fetchWorkspace = (id: number): AxiosPromise<WorkspaceType> =>
  apiClient.get(`/workspaces/${id}`);

export const syncWorkspaces = (): AxiosPromise<WorkspaceType[]> =>
  apiClient.post('/workspaces/sync');

export const setActiveWorkspaceRequest = (id: number): AxiosPromise<{ activeWorkspaceId: number }> =>
  apiClient.put(`/workspaces/active/${id}`);

export type WorkspaceStatsMap = Record<number, { totalReviews: number; avgRating: number | null }>;

export const fetchAllWorkspaceStats = (): AxiosPromise<WorkspaceStatsMap> =>
  apiClient.get('/workspaces/all-stats');
